import { SearchOutlined } from '@ant-design/icons';
import { Select, Space, Tooltip } from 'antd';
import SearchComponent from 'components/Global/SearchComponent';
import { FC } from 'react';
import styles from './index.module.scss';

const typeFilterOptions = [
	{ label: 'DEBIT', value: 'DEBIT' },
	{ label: 'CREDIT', value: 'CREDIT' },
];

type ScopeSelectProps = {
	prefix: 'Branch' | 'Department';
	placeholder: string;
	value: string[];
	options: { label: string; value: string }[];
	onChange: (value: string[]) => void;
	className: string;
	disabled?: boolean;
	loading?: boolean;
};

const ScopeTooltipList = ({ labels }: { labels: string[] }) => (
	<ul className={styles['scope-tooltip-list']}>
		{labels.map((label) => (
			<li key={label}>{label}</li>
		))}
	</ul>
);

const ScopeMultiSelect: FC<ScopeSelectProps> = ({
	prefix,
	placeholder,
	value,
	options,
	onChange,
	className,
	disabled = false,
	loading = false,
}) => {
	const labels = value.map(
		(id) => options.find((option) => option.value === id)?.label ?? id,
	);

	return (
		<div className={className}>
			<Tooltip
				title={
					value.length > 0 ? <ScopeTooltipList labels={labels} /> : null
				}
				color="#fff"
				overlayInnerStyle={{ color: '#1a1a1a' }}
			>
				<Select
					mode="multiple"
					showSearch
					optionFilterProp="label"
					placeholder={placeholder}
					options={options}
					value={value}
					onChange={(selected) => onChange((selected ?? []) as string[])}
					size="large"
					disabled={disabled}
					loading={loading}
					maxTagCount={0}
					maxTagPlaceholder={() => `${prefix}(${value.length})`}
					allowClear
					className={styles['scope-select']}
				/>
			</Tooltip>
		</div>
	);
};

type Props = {
	searchValue: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	typeFilter: string | null;
	onTypeChange: (value: string | null) => void;
	branchFilter: string[];
	onBranchChange: (value: string | number | string[]) => void;
	branchOptions: { label: string; value: string }[];
	departmentFilter: string[];
	onDepartmentChange: (value: string | number | string[]) => void;
	departmentOptions: { label: string; value: string }[];
	isDropdownLoading: boolean;
};

const CoaHeader: FC<Props> = ({
	searchValue,
	handleSearch,
	handleSearchApi,
	typeFilter,
	onTypeChange,
	branchFilter,
	onBranchChange,
	branchOptions,
	departmentFilter,
	onDepartmentChange,
	departmentOptions,
	isDropdownLoading,
}) => (
	<div className={styles['coa-header']}>
		<Space wrap>
			<SearchComponent
				className={styles['coa-header__search']}
				placeHolder="Search account no, name or description..."
				prefixIcon={<SearchOutlined />}
				handleChange={handleSearch}
				handleChangeApi={handleSearchApi}
				value={searchValue}
				size="large"
			/>
			<div className={styles['coa-header__filter']}>
				<Select
					showSearch
					optionFilterProp="label"
					placeholder="Select Type"
					options={typeFilterOptions}
					value={typeFilter}
					onChange={(value) => onTypeChange(value ? String(value) : null)}
					size="large"
					allowClear
					className={styles['scope-select']}
				/>
			</div>
			<ScopeMultiSelect
				prefix="Branch"
				placeholder="Select Branch"
				options={branchOptions}
				value={branchFilter}
				onChange={(value) => onBranchChange(value)}
				className={styles['coa-header__filter']}
				loading={isDropdownLoading}
				disabled={isDropdownLoading}
			/>
			<ScopeMultiSelect
				prefix="Department"
				placeholder="Select Department"
				options={departmentOptions}
				value={departmentFilter}
				onChange={(value) => onDepartmentChange(value)}
				className={`${styles['coa-header__filter']} ${styles['coa-header__filter--department']}`}
				loading={isDropdownLoading}
				disabled={isDropdownLoading || branchFilter.length === 0}
			/>
		</Space>
	</div>
);

export default CoaHeader;
